import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CardShimmer from "./CardShimmer";

const MovieCard = ({ query, parameter }) => {
  const [cardData, setCardData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();
  const apiKey = process.env.REACT_APP_OMDB_API_KEY;

  useEffect(() => {
    const controller = new AbortController();

    const movieData = async () => {
      setIsLoading(true);
      setHasError(false);

      try {
        const response = await fetch(
          `https://www.omdbapi.com/?${parameter}=${query}&apikey=${apiKey}`,
          { signal: controller.signal }
        );

        if (!response.ok) {
          throw new Error(`OMDB request failed (${response.status}).`);
        }

        const result = await response.json();
        setCardData(result);
      } catch (error) {
        if (error?.name !== "AbortError") {
          setHasError(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    movieData();

    return () => controller.abort();
  }, [apiKey, parameter, query]);

  const handleClick = () => {
    navigate("/info/" + query);
  };

  if (isLoading) return <CardShimmer count={1} val={1} />;
  if (hasError || !cardData?.Poster || cardData.Poster === "N/A") return null;

  return (
    <div className="flex-shrink-0 cursor-pointer" onClick={handleClick}>
      <img
        className="w-24 h-36 sm:w-32 sm:h-48 md:w-40 md:h-60 object-cover rounded-md"
        src={cardData?.Poster}
        alt="Poster"
      />
    </div>
  );
};

export default MovieCard;
